import styled from "styled-components";
import LoadingButton from "@mui/lab/LoadingButton";

const StyledLoadingButton = styled(LoadingButton)``;

export default StyledLoadingButton;
